import React from "react";
import styles from "../styles/vinos.module.css";
import { fmt } from "../domain/vinosFormat";
import { isSelectedIn, STAGE_LIMIT } from "../domain/vinosSelection";

export default function VinoItem({
    vino,
    open,
    onToggle,
    selection,
    onToggleStage,
    onEdit,
    onDelete,
}) {
    const resumen = `${vino?.tipo || "Sin tipo"}`;

    const selBadges = (
        <span style={{ marginLeft: 8, display: "inline-flex", gap: 6 }}>
            {selection.ap.includes(vino.id) && <span className={styles.pill}>Aperitivo</span>}
            {selection.pr.includes(vino.id) && <span className={styles.pill}>1º Plato</span>}
            {selection.po.includes(vino.id) && <span className={styles.pill}>Postre</span>}
        </span>
    );

    return (
        <article className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}>
            <button
                type="button"
                className={styles["accordion-header"]}
                onClick={onToggle}
                aria-expanded={open}
                aria-controls={`vino-body-${vino.id}`}
            >
                <div className={styles["accordion-title"]}>
                    <strong>{vino.nombre}</strong>
                    {selBadges}
                    <span className={styles.muted}>— {resumen}</span>
                </div>
                <span className={styles.chevron} aria-hidden>▾</span>
            </button>

            <div id={`vino-body-${vino.id}`} className={styles["accordion-body"]}>
                <div className={styles["item-row"]}>
                    <div className={styles["grid-3"]}>
                        <div className={styles.field}>
                            <label className={styles.label}>Descripción</label>
                            <div className={styles.muted}>{fmt.text(vino.descripcion)}</div>
                        </div>

                        <div className={styles.field}>
                            <label className={styles.label}>Tipo</label>
                            <div className={styles.pill}>{fmt.text(vino.tipo)}</div>
                        </div>

                        <div className={styles["item-actions"]} style={{ alignContent: "center", alignItems: "center" }}>
                            <button
                                type="button"
                                className={styles.btn}
                                style={{ padding: "8px 12px", borderRadius: "8px", height: "75%", fontSize: "16px" }}
                                onClick={() => onToggleStage(vino.id, "ap")}
                                disabled={!selection.ap.includes(vino.id) && selection.ap.length >= STAGE_LIMIT}
                                title="Añadir/Quitar en Aperitivo"
                            >
                                {isSelectedIn(selection, vino.id, "ap") ? "Quitar Aperitivo" : "Aperitivo"}
                            </button>

                            <button
                                type="button"
                                className={styles.btn}
                                style={{ padding: "8px 12px", borderRadius: "8px", height: "75%", fontSize: "16px" }}
                                onClick={() => onToggleStage(vino.id, "pr")}
                                disabled={!selection.pr.includes(vino.id) && selection.pr.length >= STAGE_LIMIT}
                                title="Añadir/Quitar en Primer plato"
                            >
                                {isSelectedIn(selection, vino.id, "pr") ? "Quitar 1º Plato" : "1º Plato"}
                            </button>

                            <button
                                type="button"
                                className={styles.btn}
                                style={{ padding: "8px 12px", borderRadius: "8px", height: "75%", fontSize: "16px" }}
                                onClick={() => onToggleStage(vino.id, "po")}
                                disabled={!selection.po.includes(vino.id) && selection.po.length >= STAGE_LIMIT}
                                title="Añadir/Quitar en Postre"
                            >
                                {isSelectedIn(selection, vino.id, "po") ? "Quitar Postre" : "Postre"}
                            </button>
                        </div>
                    </div>

                    <div className={styles["item-actions"]} style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        <button className={styles.btn} type="button" onClick={onEdit}>Editar</button>
                        <button className={`${styles.btn} ${styles.danger}`} type="button" onClick={onDelete}>
                            Eliminar
                        </button>
                    </div>
                </div>
            </div>
        </article>
    );
}
